import type { ImageProps } from '@mantine/core';
import { Image as MantineImage } from '@mantine/core';

import { DEFAULT_BRAND_IMAGE } from '../config';

const ImageMantine = MantineImage;

const ImageDefaults = ImageMantine.extend({
  defaultProps: {
    fallbackSrc: DEFAULT_BRAND_IMAGE,
  },
});

export { ImageDefaults, ImageMantine };
export type { ImageProps };
